module.exports = __webpack_public_path__ + "img/validation-new-inactive.ded8a209.svg";